.empty-table{margin-bottom:3em}.history-submitted .history.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=pregnancy-history-add-edit.component-MJGG5FG3.css.map */
